<script>
import Layout from '@layouts/main'
import GenreGridBlock from '@components/genre/genre-grid-block'
import DataLayer from '@services/data-layer/index'

export default {
    page() {
        const title = 'Genres & Moods'
        const description = 'Genres & Moods'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    components: { Layout, GenreGridBlock },
    data() {
        return {
            genres: [],
            followedGenreIds: [],
            isReady: true,
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters['auth/loggedIn']
        },
        currentUserId() {
            return this.$store.state.auth.currentUser?.members_id?.id
        },
    },
    mounted() {
        this.getGenres()
        this.getFollowedGenres()
    },
    methods: {
        async getGenres() {
            const res = await DataLayer.genres.getAll()
            this.genres = res.body || []
        },
        async getFollowedGenres() {
            if (!this.isLoggedIn || !this.currentUserId) {
                this.followedGenreIds = []
                return
            }

            try {
                const response = await DataLayer.favorites.getAll({
                    type: 'genres',
                    membersId: this.currentUserId,
                })
                const followedGenres = response.body || []
                this.followedGenreIds = followedGenres.map(item => item.genres_id?.id).filter(Boolean)
            } catch (error) {
                console.error('Error fetching followed genres:', error)
                this.followedGenreIds = []
            }
        },
        async handleToggleFollow(genre) {
            if (!this.isLoggedIn) {
                this.$router.push({ name: 'login' })
                return
            }

            if (!this.isReady || !genre) return

            this.isReady = false

            try {
                const isFollowing = this.followedGenreIds.includes(genre.id)

                if (isFollowing) {
                    await DataLayer.favorites.remove({
                        type: 'genres',
                        membersId: this.currentUserId,
                        id: genre.id,
                    })
                    this.followedGenreIds = this.followedGenreIds.filter(id => id !== genre.id)
                    this.$store.dispatch('appearance/handleNotification', {
                        message: 'Genre Unfollowed',
                        type: 'success',
                    })
                } else {
                    await DataLayer.favorites.add({
                        type: 'genres',
                        membersId: this.currentUserId,
                        id: genre.id,
                    })
                    this.followedGenreIds.push(genre.id)
                    this.$store.dispatch('appearance/handleNotification', {
                        message: 'Following Genre',
                        type: 'success',
                    })
                }
            } catch (error) {
                console.error('Error toggling genre follow:', error)
                this.$store.dispatch('appearance/handleNotification', {
                    message: this.$m('SOMETHING_WENT_WRONG'),
                    type: 'warning',
                })
            } finally {
                this.isReady = true
            }
        },
    }
}
</script>

<template>
    <Layout>
        <div class="main-heading">Genres & Moods</div>
        <BaseContent>
            <BaseSection padded>
                <GenreGridBlock
                    :genres="genres"
                    :followed-genre-ids="followedGenreIds"
                    @toggle-follow="handleToggleFollow"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.main-heading {
    @include h3;

    margin-top: $s-h;
    margin-bottom: $s-xxl;
    letter-spacing: 0.25px;

    &::after {
        display: block;
        min-height: 1px;
        margin-top: $s-xl;
        content: '';
        background: $c-dusty-gray;
        opacity: 0.1;
    }

    @include desktop {
        @include container;
        @include h1;

        margin-bottom: $s-xxl;
    }

    @include sidePadding;
}
</style>
